

















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import AdminChallengeCard from "@/components/admin/AdminChallengeCard.vue";

@Component({
  components: {
    AdminChallengeCard,
  },
  computed: mapGetters(["allChallengesForCampaign"]),
})
export default class AdminCampaignDetails extends Vue {
  get id() {
    return this.$route.params.id;
  }

  get campaign() {
    return this.$store.getters.oneCampaign(this.id);
  }
}
